import { createSelector } from '@ngrx/store';

import { DocumentControlRuleType } from '../../models';
import {
  adapter,
  State,
  validatorsFeatureKey,
} from '../../reducers/validators/validators.reducer';
import * as fromDocumentControl from '../../store';
import { isValidatorAvailableToUse } from '../../utils';
import { selectIsDocumentControlEnabled } from '../document-control/document-control.selectors';

export const selectValidatorState = createSelector<
  fromDocumentControl.State,
  [fromDocumentControl.DocumentControlState],
  State
>(
  fromDocumentControl.selectDocumentControlState,
  (state) => state[validatorsFeatureKey],
);

const { selectEntities } = adapter.getSelectors(selectValidatorState);

const selectValidatorsEntities = selectEntities;

export const selectListValidatorsEntity = (id: string) =>
  createSelector(selectValidatorsEntities, (entities) => entities[id]);

export const selectListValidators = (id: string) =>
  createSelector(
    selectListValidatorsEntity(id),
    (entity) => entity?.validators ?? [],
  );

export const selectListValidatorValue = (
  id: string,
  rule: DocumentControlRuleType,
) =>
  createSelector(
    selectListValidators(id),
    (validators) =>
      validators.find(({ name }) => name === rule)?.validatorContext.value ??
      false,
  );

export const selectIsValidatorAllowedByRule = (
  id: string,
  rule: DocumentControlRuleType,
  contextToMatch?: string,
) =>
  createSelector(
    selectIsDocumentControlEnabled,
    selectListValidators(id),
    (isRuleEnabled, validators) =>
      isRuleEnabled &&
      isValidatorAvailableToUse(validators, rule, contextToMatch),
  );
